import { Modal } from 'antd';
import { GiftOutlined } from '@ant-design/icons';
import { IReward } from '../../../../../interfaces';
import { urlHttpGov } from '../../../../../services/urls';

interface IProps {
    isVisible: boolean;
    onOk: () => void;
    reward?: IReward;
}

export default function RewardImageModal({ isVisible, onOk, reward }: IProps) {
    if (!reward) {
        return null;
    }

    return (
        <Modal
            title={
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 16, fontWeight: 700 }}>
                    <GiftOutlined style={{ color: '#1677ff' }} />
                    {reward.name}
                </div>
            }
            open={isVisible}
            onOk={onOk}
            okType="primary"
            okText="Fechar"
            cancelButtonProps={{
                style: {
                    display: 'none',
                },
            }}
            onCancel={onOk}
            centered
            width={520}
        >
            <div
                style={{
                    padding: '12px 0',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 12,
                }}
            >
                {reward.image ? (
                    <img
                        src={`${urlHttpGov}/image_reward/${reward.image}`}
                        alt={reward.name}
                        style={{
                            maxWidth: '100%',
                            maxHeight: 380,
                            objectFit: 'contain',
                            borderRadius: 10,
                            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
                        }}
                    />
                ) : (
                    <div
                        style={{
                            height: 200,
                            width: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#f8fafc',
                            borderRadius: 10,
                            color: '#94a3b8',
                            fontSize: 14,
                        }}
                    >
                        Nenhuma imagem disponível
                    </div>
                )}

                {reward.description && (
                    <div
                        style={{
                            fontSize: 13,
                            color: '#64748b',
                            textAlign: 'center',
                            lineHeight: 1.5,
                            marginTop: 4,
                        }}
                    >
                        {reward.description}
                    </div>
                )}
            </div>
        </Modal>
    );
}